<div id="cover-landing" class="text-white  flex justify-center items-center">
  <div
    class="container mx-auto flex flex-col lg:flex-row justify-center lg:justify-start items-center lg:items-start px-5 text-center lg:text-start pt-32 pb-[10rem]">

    <div class="contact lg:w-1/2 w-full">
      <h1 class="text-[#4B227A] font-bold text-2xl md:text-3xl lg:text-5xl leading-tight">
        Past Papers to Get Exams Ready

      </h1>
      <p class=" lg:text-lg text-[#2D2E32] leading-[1.8]  mx-auto lg:mx-0">
        Past papers are available to help students practice effectively and boost exam
        performance. Aligned with IB, A Level, AS Level, IGCSE, GCSE, CBSE, and ICSE
        syllabuses, each past paper is accompanied by revision notes and exam-style
        questions. </p>
      <div class="mb-12 mt-5 md:mb-2 flex lg:justify-start justify-center items-center">
        <!-- <app-main-btn
          [btnTxColor]="'white'"
          [borderColor]="'primary'"
          [btnColor]="'primary'"
          [btnName]="'Explore Past Papers'" /> -->
      </div>
    </div>

    <div class="lg:w-1/2 mt-10 lg:mt-0 flex justify-center">
      <img src="Images/paperstatic.png" alt="paper" class="w-[60%] max-w-sm lg:max-w-full" />
    </div>

  </div>
</div>